import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { ChevronDown, Weight } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

function Whitepapers4() {
  const [loading, setLoading] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [formType, setFormType] = useState(""); // stores which button opened the form
const [contactForm, setContactForm] = useState({
  fullname: "",
  company: "",
  website: "",
  email: "",
  phone: "",
  message: "",
});
const handleContactChange = (e) => {
  const { name, value } = e.target;
  setContactForm((prev) => ({ ...prev, [name]: value }));
};


const isBusinessEmail = (email) => {
  const freeDomains = [
    "gmail.com",
    "yahoo.com",
    "hotmail.com",
    "outlook.com",
    "aol.com",
    "icloud.com",
    "mail.com",
    "live.com"
  ];
  const domain = email.split("@")[1]?.toLowerCase();
  if (!domain) return false;
  return !freeDomains.includes(domain);
};


const handleContactSubmit = async (e) => {
  e.preventDefault();
 
  setLoading(true); // show loading message
  const { fullname, company, website, email, phone, message} = contactForm;


  // Basic validation
  if (!fullname || !email || !message || !company || !phone ) {
    alert("Please fill all required fields.");
      setLoading(false); // show loading message

    return;
  }
if (!isBusinessEmail(email)) {
    alert("Please enter a business email, not Gmail/Yahoo/etc.");
      setLoading(false); // show loading message

    return;
  }
 

  try {
     try {
    const emailCheckResponse = await fetch(
      `https://pinakinedgemedia.com/api/validateEmail?email=${email}`
    );
    const emailCheckData = await emailCheckResponse.json();

    if (!emailCheckData.exists) {
      setLoading(false);
      alert("❌ The entered email does not exist. Please use a valid business email.");
      return;
    }
  } catch (err) {
    setLoading(false);
    console.error("Email check failed:", err);
    alert("⚠️ Could not verify email existence. Try again later.");
    return;
  }
    const response = await fetch("https://pinakinedgemedia.com/api/sendContactMail", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
  ...contactForm,
  formType, // ✅ add formType manually here
}),

    });

    if (response.ok) {
       setShowSuccessModal(true);  // ✅ This triggers modal to open
       setLoading(false); // show loading message
       setContactForm({
        fullname: "",
        company: "",
        website: "",
        email: "",
        phone: "",
        message: "",
      });
    } else {
      alert("Error sending message.");
    }
  } catch (err) {
    console.error(err);
    alert("Error sending message.");
  }
};
  
  return (
    <div>
      <Header />
      <main>
         <AnimatePresence>
        {showSuccessModal && (
          <motion.div
            className="modal-overlay show"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <motion.div
              className="modal show"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ duration: 0.3 }}
              style={{
                background: "#fff",
                padding: "30px",
                borderRadius: "10px",
                width: "400px",
                textAlign: "center",
                boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
              }}
            >
              <h2 style={{ fontSize: "20px", marginBottom: "10px" }}>
                Message Sent!
              </h2>
              <p>Thank you for contacting us. We will get back to you shortly.</p>
              <button className="vc rg lk gh ml il hi gi _l"
                onClick={() => setShowSuccessModal(false)}
               
              >
                Close
              </button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
      
        {/* 🔹 FAQ Section */}
        <section className="i ji ii db">
        
      <div className="bb ze ki xn 2xl:ud-px-0">
        <div className="tc sf yo zf kq">
          <div className="ro1">
            <div className="animate_top rounded-md shadow-solid-13 bg-white dark:bg-blacksection border border-stroke dark:border-strokedark p-7.5 md:p-10">
            
            <div className="container">
               <div className="left">
          <img src="../images/wh4.png" className="vd" alt="Blog" />
        </div>
          <div className="right">
<h2 className="ek vj 2xl:ud-text-title-lg kk wm nb gb mk">
 Visibility that Converts: How Display Marketing Builds B2B Awareness and Lasting Loyalty
              </h2>
                <ul className="tc uf cg 2xl:ud-gap-15 fb">
                <li>
                  <span className="rc kk wm">Published On: </span> Oct 17, 2025
                   
                </li>
                <li className="jutfy">
                    <span className="rc kk wm"><b>Published by:</b></span> Pinakinedge Media
                </li>
              </ul>
          </div>
            </div>
            

              <p className="mk3 ij">
            Transforming visibility into trust, loyalty, and measurable demand
              </p>
             
               <p className="mb bgimh">
          Introduction
              </p>
 <p className="jutfy">
  In today’s hyper-connected B2B ecosystem, visibility is no longer just about being seen — it’s about being remembered. With buying cycles becoming longer and decision-making teams more complex, maintaining consistent brand presence across digital touchpoints is critical. Display marketing has emerged as one of the most powerful tools for driving not only brand awareness but also trust, recall, and long-term loyalty. In 2025, effective B2B display campaigns go far beyond impressions. They are powered by data, personalization, and intent intelligence, turning visibility into measurable engagement and sustainable relationships.
              </p>

               <p className="mb bgimh">
           The Power of Consistent Visibility
              </p>
 <p className="jutfy">
  For B2B brands, familiarity breeds trust. A potential buyer exposed to a brand multiple times across the web is 70% more likely to engage when the time comes to make a purchasing decision. Display marketing creates this consistent visibility — across websites, social platforms, and programmatic networks — ensuring that your message reaches the right audience, at the right moment, in the right context. Modern display marketing leverages AI-driven targeting to identify and engage accounts showing active buying intent. From retargeting site visitors to reaching decision-makers researching relevant topics, it ensures no opportunity is missed.
              </p>


               <p className="mb bgimh">
Building Brand Affinity and Lifetime Loyalty

              </p>

                <p className="jutfy">
                  The true measure of display success lies in its ability to connect awareness with outcomes. Advanced analytics now allow marketers to track view-through conversions, engagement depth, and multi-channel attribution. By connecting display insights with CRM and marketing automation systems, B2B marketers can map every impression to pipeline influence. This transforms display marketing from a top-funnel awareness tactic into a bottom-line growth driver — delivering quantifiable ROI and scalable business outcomes.
            </p>
                  <p className="mb bgimh">
       How Pinakinedge Media Helps
              </p>
              
 <p className="jutfy">
  At Pinakinedge Media, we specialize in transforming B2B display marketing into a precision-driven brand growth engine. We help businesses go beyond impressions — to build relationships, recognition, and revenue.
   <br/><br/>
   Strategic Audience Targeting: We combine intent, firmographic, and behavioral data to ensure your brand reaches decision-makers who matter most. 
  <br/><br/>

   Creative That Connects: Our design and content experts craft visuals and messages that capture attention and build trust at every touchpoint. 
    <br/><br/>
AI-Powered Optimization: Using machine learning, we continually refine targeting, bidding, and messaging for maximum performance. 
     <br/><br/>
     Full-Funnel Attribution: We integrate display insights with your CRM and automation tools to measure impact across the buyer journey.
    </p>
              <p className="mb bgimh">
            
Conclusion
              </p>
             <p className="jutfy">
              In 2025, display marketing is not about being visible everywhere — it’s about being visible with purpose. When powered by data, creativity, and AI, display campaigns become more than ads; they become experiences that build awareness, strengthen loyalty, and drive measurable demand. With the right strategy and partner, your brand’s next impression could be the one that converts.
              </p> 
              <div className="animate_top w-full nn/5 vo/3 vk sg hh sm yh tq">
              <form onSubmit={(e) => handleContactSubmit(e)}>
  <div className="tc sf yo ap zf xi1">
    <div className="vd to/2">
      <label className="rc" htmlFor="fullname">Full name</label>
      <input
        type="text"
        name="fullname"
        id="fullname"
        value={contactForm.fullname}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>

    <div className="vd to/2">
      <label className="rc" htmlFor="company">Company</label>
      <input
        type="text"
        name="company"
        id="company"
        value={contactForm.company}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>
  </div>

  <div className="tc sf yo ap zf xi1">
    <div className="vd to/2">
      <label className="rc" htmlFor="website">Phone number</label>
        <input
  type="text"
  name="phone"
  id="phone"
  value={contactForm.phone}
  onChange={(e) => {
    // Allow only digits
    const value = e.target.value.replace(/\D/g, "");
    setContactForm((prev) => ({ ...prev, phone: value }));
  }}
  maxLength={10} // optional: limit to 10 digits
  className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
/>

    </div>

    <div className="vd to/2">
      <label className="rc" htmlFor="email">Email address</label>
      <input
        type="email"
        name="email"
        id="email"
        value={contactForm.email}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>
  </div>
  <div className="fb">
    <label className="rc" htmlFor="message">Comment</label>
    <textarea
      placeholder="Comment"
      rows="3"
      name="message"
      id="message"
      value={contactForm.message}
      onChange={handleContactChange}
      className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 ci"
    ></textarea>
  </div>

  <div className="tc xf">
      <button
  type="submit"
  className="vc rg lk gh ml il hi gi _l"
  disabled={loading}
  onClick={() => {
    setFormType("White Paper4; Visibility that Converts: How Display Marketing Builds B2B Awareness and Lasting Loyalty");
  }}
>
  {loading ? "Please wait..." : " Post Comment"}
</button>
  </div>
</form>
            </div>
   
            </div>
          </div>
        </div>
      </div>
    </section>
       
      </main>
      <Footer />
    </div>
  );
}

export default Whitepapers4;
